import { CDN_TYPE_CMS, imageUrlCDN } from 'utils';

export const parseBannerList = bannerList => {
  return bannerList
    .filter(item => !!item.image_url)
    .map(banner => ({
      href: banner.action_url,
      imageUrl: imageUrlCDN(banner.image_url, CDN_TYPE_CMS),
      target: banner.action_url_target,
      title: banner.title,
      user_visibility: banner.user_visibility,
    }));
};
